import React from 'react';
import { PhoneIcon, MapPinIcon, ClockIcon, MailIcon } from 'lucide-react';
import { business, getWhatsAppLink } from '../data/business';
import { WhatsAppButton } from './WhatsAppButton';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
interface Row {
  icon: React.ComponentType<{
    className?: string;
  }>;
  label: string;
  value: string;
  href?: string;
  iconClass?: string;
}
export function Contact() {
  const whatsappLink = getWhatsAppLink();
  const rows: Row[] = [{
    icon: PhoneIcon,
    label: 'Teléfono',
    value: business.phone,
    href: `tel:${business.phoneHref}`,
    iconClass: 'text-[#3b82f6]'
  }, {
    icon: WhatsAppIcon,
    label: 'WhatsApp',
    value: business.whatsapp,
    href: whatsappLink ?? undefined,
    iconClass: 'text-[#25D366]'
  }, {
    icon: MapPinIcon,
    label: 'Dirección',
    value: business.address,
    href: business.mapsUrl
  }, {
    icon: MailIcon,
    label: 'Correo',
    value: business.email
  }, {
    icon: ClockIcon,
    label: 'Horarios',
    value: business.hours
  }].filter(row => row.value.length > 0);
  return <section id="contacto" className="bg-emerald-800" data-id="element-10" data-mp="3otmir2q10rwc">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-11" data-mp="3b3998vxhl54w">
        <div className="grid gap-14 lg:grid-cols-2" data-id="element-12" data-mp="3b30zhcwnufxx">
          <div data-id="element-13" data-mp="3f42z3uuhou0f">
            <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-gold-300" data-id="element-14" data-mp="3f3t9w9h9qqvs">
              Información del negocio
            </p>
            <h2 className="mt-5 font-display text-2xl font-semibold leading-snug text-ivory-50 sm:text-4xl" data-id="element-15" data-mp="3646goayp0rdt">
              {business.brand}
            </h2>
            <p className="mt-2 font-display text-lg text-sage-100" data-id="element-16" data-mp="2s5q80eh9sqt1">{business.legalName}</p>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ivory-100" data-id="element-17" data-mp="2w6s08bcrs2li">
              Atención en {business.country}. La primera consulta es privada,
              directa y sin compromiso.
            </p>
            <div className="mt-9 flex flex-col gap-4 sm:flex-row" data-id="element-18" data-mp="ue3wm0w7rd57">
              <WhatsAppButton variant="onEmerald" className="w-full sm:w-auto" data-id="element-19" data-mp="23bu62if7fsfv" />
              <a href={`tel:${business.phoneHref}`} className="inline-flex w-full items-center justify-center gap-2 rounded-sm border border-ivory-200/50 px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] text-ivory-50 transition-colors hover:border-gold-300 hover:text-gold-300 sm:w-auto" data-id="element-20" data-mp="1ycr456uiu2c4">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="2m1a9pem6s10i" />
                Llamar {business.phone}
              </a>
            </div>
          </div>

          <dl className="divide-y divide-sage-200 overflow-hidden rounded-sm border border-sage-200 bg-ivory-50" data-id="element-22" data-mp="2d98epvuvzcxm">
            {rows.map(row => <div key={row.label} className="flex items-start gap-4 p-6" data-id="element-23" data-mp="288kmx7yu2s2c">
                <row.icon className={`mt-0.5 h-5 w-5 flex-none ${row.iconClass ?? 'text-gold-600'}`} data-id="element-24" data-mp="35qug6ieswx5d" />
                <div data-id="element-25" data-mp="30xrko4qgrdmj">
                  <dt className="text-[11px] uppercase tracking-[0.2em] text-graphite-700/70" data-id="element-26" data-mp="30x9h0n1h1x4l">
                    {row.label}
                  </dt>
                  <dd className="mt-1 text-sm leading-relaxed text-graphite-800" data-id="element-27" data-mp="3d8sctmbvwdr6">
                    {row.href ? <a href={row.href} target={row.href.startsWith('http') ? '_blank' : undefined} rel={row.href.startsWith('http') ? 'noopener noreferrer' : undefined} className="underline decoration-gold-500/60 underline-offset-4 transition-colors hover:text-emerald-700" data-id="element-28" data-mp="3i7vjfb7iis19">
                        {row.value}
                      </a> : row.value}
                  </dd>
                </div>
              </div>)}
          </dl>
        </div>

        <p className="mt-10 rounded-sm border border-gold-300/40 bg-emerald-900/60 p-6 text-sm leading-relaxed text-ivory-100" data-id="element-29" data-mp="dslznytuei5t">
          <span className="font-semibold text-gold-300" data-id="element-30" data-mp="56azlzw47ufx">Costos: </span>
          {business.costsNote}
        </p>
      </div>
    </section>;
}